<div class="modal-md order-settings" id="order-settings-modal">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-align-center"
      id="modal-label"
    >
      Manage Order Settings
    </h1>
    <button
      type="button"
      class="btn btn-icon close"
      (click)="close()"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="orderSettingsForm" (ngSubmit)="saveOrderName()">
      <div class="order-settings-info">
        <div class="order-settings--items">
          <div class="order-settings--item">
            <div class="input-group order-settings-input">
              <label for="orderName">
                <span>{{ label }} Name</span>
                &nbsp;<small>(Name Your Order For Easy Reference)</small> &nbsp;
                @if (
                  orderSettingsForm.get('orderName').touched &&
                  orderSettingsForm.get('orderName').hasError('required')
                ) {
                  <small class="text-danger">Required field</small>
                }
              </label>
              <input
                [formControl]="orderName"
                type="text"
                name="orderName"
                id="orderName"
                placeholder="Enter Order Name"
              />
            </div>
          </div>

          <div class="order-settings--item">
            <div class="input-group order-settings-input">
              <label for="attention"
                >Attention&nbsp;<small>(Enter Attention Here)</small></label
              >
              <input
                [formControl]="attention"
                name="attention"
                id="attention"
                placeholder="{{
                  order.isAttentionOverridden
                    ? 'See Ship-To Address Details'
                    : 'Enter Attention'
                }}"
                (input)="isAttentionChanged = true"
              />
            </div>
          </div>

          <div class="order-settings--item">
            <div class="input-group order-settings-input">
              <label for="poNumber"
                >PO # &nbsp;<small>(Optional)</small>
              </label>
              <input
                [formControl]="poNumber"
                name="poNumber"
                id="poNumber"
                placeholder="Enter Your PO#"
              />
            </div>
          </div>
          @if (canShowTaxExempt) {
            <div class="order-settings--item">
              <div class="input-group order-settings-input">
                <label for="tax-exempt"
                  >Tax Exempt:
                  @if (!isTaxExemptAllowed) {
                    <span
                      class="color--primary-blue uppercase"
                      placement="right"
                      tooltipClass="tooltips"
                      ngbTooltip="No certificates are on file, please contact each vendor with your certificates."
                    >
                      &nbsp;<i class="fas fa-info-circle"></i>
                    </span>
                  }
                  <small
                    >&nbsp;(Exemptions will be applied for suppliers holding
                    proper exemption certificates)</small
                  ></label
                >
                <input
                  class="checkbox-dark-gray tax-exempt big-checkbox"
                  [disabled]="!isTaxExemptAllowed"
                  type="checkbox"
                  [formControl]="taxExempt"
                  id="tax-exempt"
                />
              </div>
            </div>
          }

          <div class="order-settings--item">
            <div class="input-group order-settings-input">
              <label for="notes">
                <span>Order Notes</span>
                &nbsp;<small>(These notes are not used by the Supplier)</small>
              </label>
              <textarea
                [formControl]="notes"
                name="notes"
                id="notes"
                class="notes"
                [placeholder]="orderIntoPlaceHolder"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="order-settings-controls">
        <button
          id="btn-cancel-order-settings"
          class="btn btn-outline-primary"
          type="reset"
          (click)="close()"
        >
          Cancel
        </button>
        <button
          id="btn-save-order-settings"
          [disabled]="!orderSettingsForm.valid || inProcess"
          class="btn btn-primary"
          type="submit"
        >
          @if (inProcess) {
            <i class="fal fa-sync rotate"></i>
          }
          &nbsp;Save
        </button>
      </div>
    </form>
  </div>
  @if (canEditSap) {
    <div class="modal-footer">
      <div class="order-settings-controls--edit-sap app-modal-footer">
        <a
          id="link-edit-payment-information"
          class="link link-underline small"
          (click)="close('openSapDialog')"
          >Edit Payment Information</a
        >
      </div>
    </div>
  }
</div>
